import React from 'react'
import { Paper, Typography, TextField, Button, CircularProgress, Box } from '@mui/material'
import logo from '../assets/logo.png'
import Snack from '../Snack'

const api = require('../api/api')
const request = require('../api/request')

function getCookie(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  
	if (parts.length === 2) {
		return parts.pop().split(';').shift()
	}
}

export default class LoginState extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			login: '',
			password: '',
			errors: {},
			loading: false
		}

		const cookie = getCookie('lazania')

		if (cookie) {
			api.users.check({
				cookie: cookie
			}).then(() => {
				request.setToken(cookie)
				this.props.setAppState("editor")
			}).catch(() => {

			})
		}
	}

	showError(field, message) {
		let errors = {}
		errors[field] = message

		this.setState({
			errors: errors
		})
	}

	handleClick(e) {
		e?.preventDefault()
		let { login, password } = this.state

		if (!login) {
			return this.showError('login', 'Please, enter your login')
		}

		if (!password) {
			return this.showError('password', 'Please, enter your password')
		}

		this.setState({
			errors: {},
			loading: true
		})

		api.users.login({
			email: login,
			password: new Buffer(password).toString('base64')
		}).then(data => {
			let expiry = new Date()
			expiry.setTime(expiry.getTime() + (12 * 60 * 60 * 1000))

			const token = data.token
			document.cookie = `lazania=${token}; expires=${expiry.toGMTString()}`
			request.setToken(token)

			this.props.setAppState("editor")
		}).catch((err) => {
			return Snack.instance.show('Failed to login: ' + err)
		}).finally(() => {
			this.setState({
				loading: false
			})
		})
	}

	handleChange(who, e) {
		let value = e.target.value
		let data = this.state

		data[who] = value

		this.setState({ state: data })
	}

	render() {
		return <Paper style={{ padding: '15px', maxWidth: '400px', margin: '200px auto' }}>
				<Typography variant="h4" style={{ textAlign: 'center', marginTop: '50px' }}>Connect Corner</Typography>
				<Typography variant="h5" style={{ textAlign: 'center', marginTop: '10px' }}>Login</Typography>

				{/* <img src={logo} style={{ marginLeft: 'auto', marginRight: 'auto', display: 'block', width: '50%' }} /> */}
				<br/>


				<form onSubmit={this.handleClick.bind(this)}>
					<TextField disabled={this.state.loading} value={this.state.login} onChange={this.handleChange.bind(this, 'login')} error={this.state.errors['login'] && true || false} label={this.state.errors['login'] || "Login"} size="small" style={{ marginBottom: '5px', width: '50%', marginLeft: 'auto', marginRight: 'auto', display: 'block' }} />
					<TextField disabled={this.state.loading} value={this.state.password} onChange={this.handleChange.bind(this, 'password')} type="password" error={this.state.errors['password'] && true || false} label={this.state.errors['password'] || "Password"} size="small" style={{ width: '50%', marginLeft: 'auto', marginRight: 'auto', display: 'block', marginBottom: '32px' }} />

					<Box sx={{ m: 1, position: 'relative' }}>
						<Button type="submit" disabled={this.state.loading} onClick={this.handleClick.bind(this)} variant="contained" style={{ width: '50%', marginLeft: 'auto', marginRight: 'auto', display: 'block', marginBottom: '20px' }} >login</Button>
						{this.state.loading && (
							<CircularProgress
								size={24}
								sx={{
									position: 'absolute',
									top: '50%',
									left: '50%',
									marginTop: '-12px',
									marginLeft: '-12px',
								}}
							/>
						)}
					</Box>
				</form>
		</Paper>
	}
}